import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__